export const ADMIN_CONFIGS_QUERY_KEY = () => ["configs"];
